// Serviço da tela "Consulta de Protocolos": busca os protocolos finalizados
// do usuário logado, com andamento de tramitação, na API de Protocolo
// (GET /protocolo/documentos-protocolo/{pessoaId}).

import { authService } from '../../../services';
import protocoloService from './protocoloService';

const getPessoaId = (user) => {
  const token = authService.getToken();

  if (token) {
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      if (payload.pessoaId) return payload.pessoaId;
    } catch (e) {
      // token inválido, cai no fallback abaixo
    }
  }

  return user?.pessoaId || user?.PessoaID || null;
};

export const consultaProtocolosService = {
  async getProtocolos() {
    const user = authService.getCurrentUser();
    const pessoaId = getPessoaId(user);

    if (!pessoaId) {
      return { success: false, error: 'Não foi possível identificar o usuário logado.' };
    }

    try {
      const data = await protocoloService.listarDocumentosProtocoloPorPessoa(pessoaId);
      return { success: true, data };
    } catch (error) {
      return { success: false, error: error.message || 'Erro ao carregar protocolos' };
    }
  }
};
